import script from "./Ucenter.vue?vue&type=script&setup=true&lang=js"
export * from "./Ucenter.vue?vue&type=script&setup=true&lang=js"

import "./Ucenter.vue?vue&type=style&index=0&id=05e703c3&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e703c3"]])

export default __exports__